/* eslint-disable react-hooks/exhaustive-deps */
import { useAppBaseContext } from "providers";
import { useEffect, useMemo } from "react";
import type { Unit } from "variables/enums";
import { useAuthStore } from "stores/authStore";
import { useProductConfiguratorStore } from "../store/ProductConfiguratorStore";
import type { TopologyData } from "../store/ProductConfiguration.types";

type UseLoadProductState = {
  nodeId: string;
  units: Unit;
  seriesId: number;
  topologyData: TopologyData | undefined;
  productName: string;
};

export const useLoadProductState = ({
  nodeId,
  units,
  seriesId,
  topologyData,
  productName,
}: UseLoadProductState) => {
  const { actions } = useProductConfiguratorStore();
  const { lang } = useAppBaseContext() as { lang: string };
  const tenant = useAuthStore().currentUser?.tenant;

  const topologyDataMemo = useMemo(
    () => topologyData,
    [
      topologyData?.dummyType,
      topologyData?.groupPosition,
      topologyData?.wizardType,
    ],
  );

  useEffect(() => {
    const hasMinimumNecessaryData = seriesId && tenant && lang;
    if (hasMinimumNecessaryData) {
      if (nodeId && !topologyDataMemo?.isDummy) {
        actions.loadPersistedState({
          nodeId,
          units,
          seriesId,
          language: lang,
          country: tenant ?? "",
          topologyData: topologyDataMemo,
          productName: productName,
        });
      } else {
        actions.loadDefaultState({
          seriesId,
          language: lang,
          units,
          country: tenant ?? "",
          topologyData: topologyDataMemo,
        });
      }
    }

    return actions.clear;
  }, [actions, lang, nodeId, seriesId, tenant, units, topologyDataMemo]);
};
